/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Video_Encoding_StandardInputs */



/**
* | output |
* | --- |
* | "Encoding video with AD audio (standard)..." |
*
* @param {Audio_Description_Export_Status_Video_Encoding_StandardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_standard = /** @type {((inputs?: Audio_Description_Export_Status_Video_Encoding_StandardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_StandardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encodage de la vidéo avec l'audio AD (standard)...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videocodierung mit AD-Audio (Standard)...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codifica video con audio AD (standard)...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кодирование видео с аудиосигналом AD (стандартный)...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Codificación de vídeo con audio AD (estándar)...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用 AD 音频（标准）对视频进行编码……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD オーディオ (標準) でビデオをエンコードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD ऑडियो (मानक) के साथ वीडियो एन्कोडिंग...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Codificação de vídeo com áudio AD (padrão)...")
	return /** @type {LocalizedString} */ ("Encoding video with AD audio (standard)...")
});